const config = {
  api: {
    baseUrl: 'https://spiralproject.org/api/v1.0.0'
  }
}

module.exports = config
